import { ModalRushPage, SettingsLayout } from '@/ui'
import { HOME_PATH, useNavigateBack } from '@/libs'
import { CompanySettingsSidebar } from './CompanySettingsSidebar'
import { useLocation } from 'react-router-dom'
import { useState } from 'react'

export const CompanySettingsOutlet = () => {
  const location = useLocation()
  const [previousPath] = useState<string>(() =>
    location.state && location.state.previousPath ? location.state.previousPath : HOME_PATH,
  )
  const back = useNavigateBack({ fallback: previousPath })

  return (
    <ModalRushPage back={back}>
      {props => <SettingsLayout {...props} sidebar={<CompanySettingsSidebar />} />}
    </ModalRushPage>
  )
}
